import { render, staticRenderFns } from "./NewXaIndex.vue?vue&type=template&id=7d7b8135&scoped=true&"
import script from "./NewXaIndex.vue?vue&type=script&lang=js&"
export * from "./NewXaIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewXaIndex.vue?vue&type=style&index=0&id=7d7b8135&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b8135",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7d7b8135', component.options)
    } else {
      api.reload('7d7b8135', component.options)
    }
    module.hot.accept("./NewXaIndex.vue?vue&type=template&id=7d7b8135&scoped=true&", function () {
      api.rerender('7d7b8135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/NewXaIndex.vue"
export default component.exports